// extracted by mini-css-extract-plugin
export default {"departments":"QF-z","departmentHeading":"RF-z","departmentSection":"SF-z","departmentName":"TF-z","departmentLink":"UF-z","expandIcon":"VF-z"};